(function () {
    "use strict";

    // @ngInject
    function AccountControllerCtor($scope, CompaniesManager, $stateParams, UsersManager, AppConfigService, SavingIndicatorService, $injector, $window, OnboardingService, Enums, $state, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'AccountController';

        this.$window = $window;
        this.isSavingIndicatorActive = { value:false };
        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
        this.currentUserIsVendor = this.user.isVendor();
        SavingIndicatorService.registerModel(this.user);
        this.CompaniesManager = CompaniesManager;
        this.company = this.CompaniesManager.getCurrCompany();
        this.OnboardingService = OnboardingService;
        this.Enums = Enums;
        this.$state = $state;
        this.AppStates = AppStates;

        this.topNavigationActive = false;

        this.OnboardingService.triggerTrialIfNeeded($stateParams.shouldStartTrial);
    }

    Controllers.AccountController = Class(Controllers.BaseController, {

        constructor: AccountControllerCtor,

        onStartTrialClicked: function onStartTrialClicked() {
            this.OnboardingService.openInProductIntakeForm(this.Enums.IntakeFormSource.settings);
        }
    });
}());
